import { mapState, mapMutations, mapActions } from 'vuex'
import degree from '@/assets/json/degree'
import api from '../../api'
import { removeClass } from './dom'
import { dealResumeDomScroll, get_tUser } from '../../assets/js/util'
const oss = require('ali-oss')
import { dataURLtoBlob, blobToFile } from '@/assets/js/util'
import editorPlaceholder from '@/assets/json/editor-placeholder'
import editorPlaceholderDefault from '@/assets/json/editor-placeholder-default'
import { getErrorTextPosition, getOffsetRelative, getErrorTextRegExp } from '@/assets/js/editorError'
import { EN_CV_STYLES, CN_CV_STYLES } from '@/assets/js/const'

import { uuid } from 'vue-uuid'
import {getSchollTags} from "@/api/list/static";
let moment = require('moment')
let sortModuleTimeName = null

let timer

const MAX_WIDTH = 720
const MIN_WIDTH = 415

export const cvMixin = {
	data () {
		return {
			formData: {},
			isCommon: false,  // 是否添加相同公司的工作子经历
			commonState: false,   // 子经历提交状态
			currentCharIndex: 0, // 当前字符的索引
      typingSpeed: 100, // 每个字符的显示速度（毫秒）
			displayedText: ''
		}
	},
	computed: {
		...mapState('editor', [ 'openSidebarModule', 'currentInfo', 'backUpInfo', 'saveFormDataByDialog', 'textEditorScrollTop', 'emitShowDownloadResumeBox', 'isFirstCvInfo', 'optimizationResult' ]),
		...mapState('me', [ 'personInfo' ]),
		alertData () {
			return {
				show: true,
				type: 'message',
				messageTitle: '温馨提示',
				showCancelButton: true, //取消按钮
				showConfirmButton: true, // 确定按钮
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				confirmButtonClass: 'cvs-edit-cancelButtonClass',
				cancelButtonClass: 'cvs-edit-confirmButtonClass',
			}
		},
		isMemberAccount() {
      return this.personInfo.is_membership
    },
	},
	watch: {
		'currentInfo.data.id': {
			handler (val) {
				this.formData = this.currentInfo.data
			},
			deep: true
		},
		textEditorScrollTop: {
			handler (val) {
				if (val) {
					this.$nextTick(() => {
						let scrollEl = document.querySelector(`.edit-module-index-main`)
						scrollEl.scrollTo({ top: 0, behavior: 'smooth' })
						this.setTextEditorScrollValue(false)
					})
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapMutations('editor', [ 'setCurrentInfo', 'setDealCheck', 'setSuggestInfo', 'setOpenSidebarModule', 'setFormDataFn', 'setTextEditorScrollValue', 'emitShowDownBox', 'setIsShowDownloadResume', 'updateLibraryState', 'setOptimizationData' ]),
		...mapActions('app', [ 'setAlertData' ]),
    ...mapMutations('experience', [ 'updateSidebarOption', 'updateCurrentExperienceType' ]),
		useOptimizationContent(result) {
			this.formData.description = result;
		},
		handleClickAiBtn() {
			const alertData = {
				...this.alertData,
				confirmButtonText: '确认润色',
				cancelButtonText: '我再想想',
				messageContent: `为了保证润色效果，建议您将内容写完整后再润色哦～`,
				confirm: async close => {
					this.handleClickAiOptimization()
					close()
				},
				cancel: close => {
					close()
				},
			}
			this.setAlertData(alertData)
		},
		startTyping(fullText) {
			if (!fullText) return;
			if (this.currentCharIndex < fullText.length) {
				this.displayedText += fullText[this.currentCharIndex];
				this.currentCharIndex++;
				this.setOptimizationData({
					status: 'over',
					result: this.displayedText
				})
				setTimeout(() => this.startTyping(fullText), this.typingSpeed);
			}
		},
		async handleClickAiOptimization() {
			try {
				this.setOptimizationData({
					status: 'loading',
					result: this.optimizationResult
				});
	
				if (!this.isMemberAccount) {
					setTimeout(() => {
						this.setOptimizationData({
							status: 'over',
							result: ''
						})
					}, 500)
				} else {
					const { data } = this.currentInfo || {};
					const res = await api.AI.getAIOptimizationResult({
						text: data.description
					})

					if (res.code === 2030) {
						this.setOptimizationData({
							status: !!this.optimizationResult ? 'over' : 'initial',
							result: this.optimizationResult
						})
						return this.$message.error('AI简历润色次数不足')
					}

					if (res.code === 1000) {
						this.displayedText = '';
						this.startTyping(res.data.result);
					} else {
						this.setOptimizationData({
							status: 'error',
							result: ''
						})
					}
				}
			} catch (error) {
				this.setOptimizationData({
					status: 'error',
					result: ''
				})
				console.log(error)
			}
		},
		// 初始化form的数据
		initFormData () {
			// let formData = {}
			// if (this.isFirstCvInfo.isFirst && this.currentInfo.type === 'edus' && (this.isFirstCvInfo.data.cust_uni_name || this.isFirstCvInfo.data.cust_degree || this.isFirstCvInfo.data.edu_type || this.isFirstCvInfo.data.graduate_at)) {
			// 	if(this.isFirstCvInfo.data.cust_uni_name && !this.currentInfo.data.university){
			// 		formData.university = this.isFirstCvInfo.data.cust_uni_name
			// 		formData.university_id = ""
			// 	}
			// 	if(this.isFirstCvInfo.data.cust_degree && !this.currentInfo.data.degree){
			// 		formData.degree = this.isFirstCvInfo.data.cust_degree
			// 	}
			// 	if(this.isFirstCvInfo.data.cust_degree && !this.currentInfo.data.degree_id){
			// 		formData.degree_id = degree.find(item => item.cn === this.isFirstCvInfo.data.cust_degree || item.en === this.isFirstCvInfo.data.cust_degree).id
			// 	}
			// 	if(this.isFirstCvInfo.data.edu_type && !this.currentInfo.data.edu_type){
			// 		formData.edu_type = this.isFirstCvInfo.data.edu_type
			// 	}
			// 	if(this.isFirstCvInfo.data.graduate_at && !this.currentInfo.data.end_at){
			// 		formData.end_at = moment(this.isFirstCvInfo.data.graduate_at).format("YYYY-MM")
			// 	}
			// 	this.setCurrentInfo({
			// 		...this.currentInfo,
			// 		data: {...formData}
			// 	})
			// }

			this.formData = this.currentInfo.data
			if(this.oldContent !== undefined){
				this.oldContent = this.formData.description
			}

			// this.formData = { ...this.formData, ...this.currentInfo.data }
			// if (this.currentInfo.type === 'edus') {
			// 	const index = degree.findIndex(item => item.id === this.formData.degree_id)
			// 	this.degreeData = index > -1 ? degree[index] : {}
			// }
			console.log("formData", this.formData)
		},
		// 初始化日期选择器时的至今数据
		initDateOptions () {
			let { basic_info: { lang } } = this.cvDetail
			if (this.currentInfo.type !== 'edus') {
				this.pickerOptions = {
					shortcuts: [
						{
							text: lang === 'en' ? 'Present' : '至今',
							onClick: (picker) => {
								picker.$emit('pick', '')
								setTimeout(() => {
									this.currentInfo.data.present = lang === 'cn' ? '至今' : 'Present'
									this.currentInfo.data.end_at = null
									this.formData.present = lang === 'cn' ? '至今' : 'Present'
									this.formData.end_at = null
								}, 50)
							}
						}
					]
				}
			}
		},
		// 将 state 里面的数据都清除掉
		resetEditState (isBack) {
			this.resetCvData(isBack)
			this.setSuggestInfo({})
			if (this.isCommon) {
				this.isCommon = false
				return true
			}
			this.setCurrentInfo({
				type: '',
				data: {},
				operation: ''
			})
		},
		resetCvData (isBack) {
			console.log('resetCvData=>>>',this.currentInfo)
			let { type, operation, data } = this.currentInfo
			for (let key in data) {
				this.currentInfo.data[key] = this.backUpInfo.data[key]
			}
			if (type !== 'custom' && type !== 'extras' && (operation === 'add' || operation === 'module') && isBack) {
				// this.$store.state.editor[type].pop()
				this.$store.state.editor[type] = this.$store.state.editor[type].filter(item => item.id)
			} else if (type === 'custom' && isBack) {
				this.$store.state.editor.create_custom.pop()
			}
			if (operation === 'module' && isBack) {
				this.cvDetail.submodule_info.sections_position.pop()
			}
		},
		// 关闭弹窗
		close () {
			this.$emit('close')
		},
		// 结束时间发生变化
		endAtChange (val) {
			this.formData.end_at = val
			this.$forceUpdate()
		},
		// 返回未保存提示弹窗
		showAlert () {
			const alertData = {
				...this.alertData,
				confirmButtonText: '保存',
				cancelButtonText: '不保存',
				messageContent: `<p>还有内容尚未保存，是否保存再离开？</p>`,
				confirm: async close => {
					this.$store.commit('editor/setAutoModel',false)
					if (this.debounceSave) {
						this.debounceSave()
					} else {
						this.$emit('saveFormData')
					}
					close()
				},
				cancel: async close => {
					this.$store.commit('editor/setAutoModel',false)
					this.resetEditState(true)
					close()
					if (this.saveFormDataByDialog) {
						this.saveFormDataByDialog()
						this.setFormDataFn(null)
					}
					//打开右边tab
					this.setOpenSidebarModule({
						...this.openSidebarModule,
						state: true,
					})
					if(this.emitShowDownloadResumeBox){
						this.setIsShowDownloadResume(true)
						this.emitShowDownBox(false)
					}
				},
				// cancel: async close => {
				// 	close()
				// }
			}
			this.setAlertData(alertData)
		},
		// 点击返回事件
		back () {
			let { data } = this.backUpInfo
			if (this.contrastInitData(this.currentInfo.data, data)) {
				this.showAlert()
				return 'different'
			} else {
				this.resetEditState(true)
			}
		},
		// extras点击返回
		extrasBack () {
			if (this.verifyExtraData()) {
				this.showAlert()
				return 'different'
			} else {
				this.resetEditState(true)
			}
		},
		// 基本信息返回
		profileBack () {
			let { data } = this.backUpInfo
			let fields = [ 'username', 'phone', 'email', 'address', 'homepage', 'wechat', 'linked_in', 'height', 'weight', 'ethnic', 'hometown', 'political_status', 'marriage', 'gender', 'birthday', 'exp_job', 'current_job', 'expected_salary' ]
			for (let i = 0; i < fields.length; i++) {
				if (this.formData[fields[i]] !== data[fields[i]]) {
					this.showAlert()
					return 'different'
				}
			}
			this.resetEditState()
		},
		// 校验是否有无更改
		verifyExtraData () {
			let localData = this.backUpInfo.data
			let keys = this.currentInfo.data ? Object.keys(this.currentInfo.data) : []
			for (let i = 0; i < keys.length; i++) {
				let localDataDescription = localData[keys[i]]?.description
				let formDataDescription = this.currentInfo.data[keys[i]]?.description
				if (!!localData[keys[i]] && !!this.currentInfo.data[keys[i]] && (localDataDescription !== formDataDescription && (!!formDataDescription || !!formDataDescription))) {
					return true
				}
			}
		},
		// 校验两份经历数据是否一致
		contrastInitData (info, experience) {
			let fields = Object.keys(info)
			for (let i = 0; i < fields.length; i++) {
				if (fields[i] === 'start_at' || fields[i] === 'end_at') {
					let time1 = moment(info[fields[i]]).format('YYYY-MM')
					let time2 = moment(experience[fields[i]]).format('YYYY-MM')
					if (time1 !== time2) return true
				} else if (fields[i] === 'description') {
					// let desc1 = info.description && info.description.replace(/↵/g, '').replace(/\s+/g, '')
					let desc1 = info.description && info.description.replace(/↵/g, '')
					// let desc2 = experience.description && experience.description.replace(/↵/g, '').replace(/\s+/g, '')
					let desc2 = experience.description && experience.description.replace(/↵/g, '')
					if (desc1 !== desc2) return true
				} else if (info[fields[i]] !== experience[fields[i]] && fields[i] !== 'checked') {
					return true
				}
			}
		},
		// 判断某一段经历里面是否为空
		infoNotEmpty (info, type) {
			if (type === 'extras') {
				let extrasField = info ? Object.keys(info) : []
				for (let i = 0; i < extrasField.length; i++) {
					if (info[extrasField[i]].description) return true
				}
			} else if (type === 'profile') {
				let fields = [
					'username',
					'phone',
					'email',
					'address',
					'homepage',
					'wechat',
					'linked_in',
					'height',
					'weight',
					'ethnic',
					'hometown',
					'political_status',
					'marriage',
					'gender',
					'birthday',
					'exp_job',
					'current_job',
					'expected_salary'
				]
				for (let i = 0; i < fields.length; i++) {
					if (info[fields[i]]) return true
				}
				return false
			} else {
				let fields = [
					'company',
					'university',
					'major',
					'degree',
					'uni_school',
					'city',
					'dept',
					'title',
					'name',
					'start_at',
					'end_at',
					'present',
					'description',
					'username'
				]
				for (let i = 0; i < fields.length; i++) {
					if (info[fields[i]]) return true
				}
			}
		},
		// 简历每个模块的title
		getSectionTitle ({ id, type }) {
			let { submodule_info: { custom_sections_titles }, submodule_info } = this.cvDetail
			if (id) {
				return custom_sections_titles[`${ id }_title`]
			} else if (type === 'extras') {
				return submodule_info.extras_title
			} else {
				return submodule_info[`${ type }_title`]
			}
		},
		// 选择专业
		selectMajor (data) {
			this.currentInfo.data = {
				...this.currentInfo.data,
				major: data.name,
				major_id: data.id
			}
		},
		// 选择学历
		selectDegree (data) {
			let { basic_info: { lang } } = this.cvDetail
			this.formData = {
				...this.formData,
				degree: lang === 'en' ? data.en : data.cn,
				degree_id: data.id
			}
		},
		// 选择学校
		async selectUniversity (data) {
			const schoolTag = ['985', '211', '双一流', '海外前100']
			try {
				let { id } = data
				let res = await api.staticApi.getSchollTags(id)
				if (res.code === 1000) {
					console.log(res, "===============>aaaa")
					let { university_tags } = res.data
					let show_tags = university_tags.filter(item => schoolTag.includes(item))
					this.formData = {
						...this.formData,
						show_tags,
						university: data.name,
						university_id: data.id
					}
					this.$forceUpdate()
				}
			} catch (e) {
				console.log(data, "=================》data")
				this.formData = {
					...this.formData,
					university: data.name,
					university_id: data.id
				}
				this.$forceUpdate()
			}
		},
		// 选择学校标签
		schoolTagChange(val) {
			console.log(val, "==================>lalala")
			this.formData = {
				...this.formData,
				show_tags: val
			}
			this.$forceUpdate()
		},
		// 选择城市
		selectCity (data) {
			this.formData = {
				...this.formData,
				city: data.name,
				city_id: data.id
			}
		},
    // 经历库超出30条提示
    showModuleMaxTips () {
      const alertData = {
        ...this.alertData,
        messageTitle: '创建失败',
        showCancelButton: true,
        confirmButtonText: '前往经历库',
        messageContent: `当前模块下经历数量已达到上限，请前往「经历库」，删除多余经历`,
        confirm: async close => {
          close()
          let arr = ['edus','orgs','works','extras','project_experience']
          let jumpParam = {type: this.currentInfo.type, index: arr.indexOf(this.currentInfo.type)}
          // 跳转到相应的经历库
          this.setCurrentInfo({
            operation: '',
            type: '',
            data: {}
          })
          setTimeout(()=>{
            // this.updateSidebarOption('library')
						this.updateLibraryState(true)
            this.updateCurrentExperienceType(jumpParam)
          })
        },
        cancel: close => {
          close()
        },
      }
      this.setAlertData(alertData)
    }
	}
}
export const dealCvDataMixin = {
	computed: {
		...mapState('global', [ 'ossBeaseOptions' ]),
    ...mapState('experience', [ 'experienceTitleList', 'backUpExperienceList' ]),
		...mapState('editor', [ 'resumeWidth', 'isUnfold', 'saveFormDataByDialog', 'backUpInfo', 'cvDetail' ,'currentInfo', "isFirstCvInfo", "commonIndex"]),
    alertData () {
			return {
				show: true,
				type: 'message',
				messageTitle: '温馨提示',
				showCancelButton: true, //取消按钮
				showConfirmButton: true, // 确定按钮
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				confirmButtonClass: 'cvs-edit-cancelButtonClass',
				cancelButtonClass: 'cvs-edit-confirmButtonClass',
			}
		},
		// 简历的模块排序
		sectionPosition () {
			let { submodule_info: { sections_position } } = this.cvDetail
			return sections_position
		},
		// 简历的语言
		cvLang () {
			let { basic_info: { lang } } = this.cvDetail
			return lang || 'cn'
		},
		// 其他模块的排序
		extrasPosition () {
			let { submodule_info: { extras_position } } = this.cvDetail
			if (extras_position && extras_position.length) {
				return extras_position.map(item => item.slice(0, -1))
			} else {
				return [ 'language', 'certificate', 'other', 'interest', 'skill' ]
			}
		},
		// 上传头像弹窗的Faq
		avatarFaq () {
			return [
				{
					title: '简历上是否应该放照片？',
					description: '<p>写简历最常见问题之一，基本上遵守两个原则：</p> <ol> <li>民企/国企推荐放照片，外企推荐不放照片</li> <li>中文简历推荐放照片，英文简历推荐不放照片</li> </ol> <p>如果决定放照片，一定要使用专业照相馆拍摄的登记照/职业照，一定不要用生活照。</p>'
				},
				{
					title: '简历上的照片应该是什么样的？',
					description: '<p>对于头像，我们推荐如下格式：</p> <ul> <li>剪裁：头部上方空一定距离，下面要露到肩膀左右，不要剪裁成大头照</li> <li>底色：白色最好，蓝色/黑色其次，红色和其他颜色不推荐（像结婚照）；</li> <li>发型：长发盘起来；短发梳好，尽可能不要遮挡脸部；避免头发凌乱；</li> <li>表情：微笑即可，不要特别严肃也不要大笑；</li> <li>着装：申请严肃的行业（如金融）建议西装（男生配领带；女生不必）；互联网行业建议深色衬衫或T恤；</li> </ul>'
				},
				{
					title: '是否有好的和不好的头像案例对比？',
					description: '<img alt=\'简历头像配图\' src=\'https://files.wondercv.com/headshot_comp.png\' />'
				}
			]
		},
		// 每个模块的预设文案
		placeholder (type) {
			let { basic_info: { cv_type } } = this.cvDetail
			if(type){
				type = cv_type ? cv_type.replace(/_(cn|en)$/gim, '') : ''
			}
			return {
				...editorPlaceholderDefault,
				...(editorPlaceholder[type] || {})
			}
		},
		// 当前其他模块中存在description的数据
		currentExtrasCount () {
			let count = 0
			this.extrasPosition.forEach(item => {
				if (this.extras[item] && this.extras[item].description) {
					count += 1
				}
			})
			return count
		}
	},
	methods: {
		...mapActions('editor', [ 'updateCvDetail', 'updateProfileData', 'createProfileData', 'createCvDetail', 'updateVipProfileData' ]),
		...mapActions('manage', [ 'getFilterModule' ]),
		...mapMutations('experience', [ 'updateSidebarOption', 'updateCurrentExperienceType', 'updateExperienceList']),
    ...mapActions('app', [ 'setAlertData' ]),
		...mapMutations('editor', [ 'setCurrentInfo', 'setFormDataFn', 'setCvDetail', 'setProfileData', 'setBackUpProfile', 'setModuleData', 'setExtrasData', 'setResumeWidthByValue', 'setTextEditorScrollValue', 'updateCompanyDisabled', 'updateLibraryState']),
		// 点击按钮的时候回复经历库操作数据
		updateLibrary() {
			//把备份数据同步到当前经历库数据中
			this.updateExperienceList(JSON.parse(JSON.stringify(this.backUpExperienceList)))
		},
		// 编辑基本信息
		editProfile (page) {
			this.updateLibrary()
			const fn = () => {
				if (!this.isMentorEditor && type !== 'profile') {
					this.setCurrentInfo({
						type: 'profile',
						operation: 'edit',
						data: this.profile
					})
				}
			}
			let { type, operation } = this.currentInfo
			if (operation && type !== 'profile' && page === 'preview') {
				let status = type === 'extras' ? this.extrasBack() : type === 'profile' ? '' : this.back()
				if (status === 'different') {
					this.setFormDataFn(fn)
					return
				}
			}
			fn()
		},
		// 编辑模块  isCommon: 是否相同公司添加工作子经历
	  editModule (data, pData, operation, page, isCommon = false) {
			// 编辑子经历，公司名不允许修改
			if (data.is_sub_item) {
				this.updateCompanyDisabled(true)
			} else {
				this.updateCompanyDisabled(false)
			}
			this.updateLibrary()
			console.log("编辑模块",this.currentInfo, data, pData, operation)
			console.log('mixins-infos=>>>1', this.commonIndex, JSON.parse(JSON.stringify(this.works)))
			// 教育经历添加时增加学校tag
			if(pData.type === 'edus' && operation === 'add'){
				data.show_tags = []
			}
			const fn = async () => {
				let title = this.getSectionTitle(pData)
				let info = {
					data,
					type: pData.type === 'custom' ? pData.id : pData.type,
					operation,
					title
				}
				if (this.isFirstCvInfo.isFirst && info.type === 'edus' && (this.isFirstCvInfo.data.cust_uni_name || this.isFirstCvInfo.data.cust_degree || this.isFirstCvInfo.data.edu_type || this.isFirstCvInfo.data.graduate_at)) {
					if(this.isFirstCvInfo.data.cust_uni_name && !info.data.university){
						info.data.university = this.isFirstCvInfo.data.cust_uni_name
						info.data.university_id = ""
					}
					if(this.isFirstCvInfo.data.cust_degree && !info.data.degree){
						info.data.degree = this.isFirstCvInfo.data.cust_degree
					}
					if(this.isFirstCvInfo.data.cust_degree && !info.data.degree_id){
						info.data.degree_id = degree.find(item => item.cn === this.isFirstCvInfo.data.cust_degree || item.en === this.isFirstCvInfo.data.cust_degree).id
					}
					if(this.isFirstCvInfo.data.edu_type && !info.data.edu_type){
						info.data.edu_type = this.isFirstCvInfo.data.edu_type
					}
					if(this.isFirstCvInfo.data.graduate_at && !info.data.end_at){
						info.data.end_at = moment(this.isFirstCvInfo.data.graduate_at).format("YYYY-MM")
					}
				}

        // 在添加模块前判断有没有超过30条
        if(operation === 'add') {
         let res = await api.cvsEditor.isModelOverMore30({
            module_type: info.type,
            lang: this.cvDetail.basic_info.lang,
          })
          if(res.code !== 1000) {
            const alertData = {
              ...this.alertData,
              messageTitle: '创建失败',
              showCancelButton: true,
              confirmButtonText: '前往经历库',
              messageContent: `当前模块下经历数量已达到上限，请前往「经历库」，删除多余经历`,
              confirm: async close => {
                close()
                let jumpParam = {type: info.type, index: this.experienceTitleList.findIndex(item => item.type == info.type)}
                // 跳转到相应的经历库
                console.log(jumpParam);
                this.setCurrentInfo({
                  operation: '',
                  type: '',
                  data: {}
                })
                setTimeout(()=>{
									this.updateLibraryState(true)
                  // this.updateSidebarOption('library')
                  this.updateCurrentExperienceType(jumpParam)
                })
              },
              cancel: close => {
                close()
              },
            }
            this.setAlertData(alertData)
            return
          }
        }
				if (operation === 'add' && info.type !== 'extras') {
					let infos = this.$store.state.editor[info.type] || []
					if (this.commonIndex > -1) {
						infos.splice(this.commonIndex, 0, data)
					} else {
						infos.push(data)
					}
					this.setModuleData({ type: info.type, info: infos })
				} else if (info.type === 'extras') {
					info.data = {
						skill: {
							name: '技能',
							description: null
						},
						language: {
							name: '语言',
							description:null
						},
						other: {
							name: '活动',
							description:null
						},
						interest: {
							name: '兴趣',
							description:null
						},
						certificate: {
							name: '证书/执照',
							description:null
						},
						...data
					}
					this.setExtrasData(info.data)
				}
				// 设置currentInfo
				// this.setCurrentInfo({...info, isCommon})
				this.setCurrentInfo(info)
				this.setTextEditorScrollValue(true)
				// this.formData = info.data
			}
			// 清除点击check时候的高亮的class
			let els = document.querySelectorAll('.high-light-error')
			for (let i = 0; i < els.length; i++) {
				if (els[0]) removeClass(els[0], 'high-light-error')
			}
			if ((this.currentInfo.data.id === data.id || (this.currentInfo.type === 'extras' && pData.type === 'extras')) && data.id) {
				return
			} else if (this.currentInfo.operation) {
				console.log(isCommon, 'isCommon')
				let status = this.currentInfo.type === 'extras' ? this.extrasBack() : this.currentInfo.type === 'profile' ? this.profileBack() : this.back()
				console.log('operation status =>>>', status)
				if (status === 'different') {
					this.setFormDataFn(fn)
					return
				}
			}
			// else if ((operation === 'add' && this.isMentorEditor)) {
			// 	return
			// }
			if(data.id !== this.currentInfo.data.id){
				this.$store.commit('editor/setAutoModel',false)
			}
			fn()
			// 添加模块时把resume的锚点定位到某一页的可视区之内
			this.$nextTick(() => {
				const scrollEl = document.querySelector('.cvs-component')
				const moduleEls = document.querySelectorAll('.section-undefined')
				if (moduleEls && moduleEls.length) {
					let { pageIndex, pageElHeight } = dealResumeDomScroll(moduleEls)
					this.$emit('dealCheckDomScroll', { pageIndex, pageElHeight })
					scrollEl.scrollTo({ top: moduleEls[0].offsetTop - 180, behavior: 'smooth' })
				}
			})
		},
		// 通过type拿到对应模块的数据
		getInfosByType ({ id, type }) {
			if (type === 'custom') {
				return this.$store.state.editor[id]
			} else if (type === 'extras') {
				return this.$store.state.editor.extras
			} else {
				return this.$store.state.editor[type]
			}
		},
		// 简历每个模块的title
		getSectionTitle ({ id, type }) {
			// console.log(id, type)
			let { submodule_info: { custom_sections_titles }, submodule_info } = this.cvDetail
			if (id) {
				return custom_sections_titles[`${ id }_title`]
			} else if (type === 'extras') {
				return submodule_info.extras_title
			} else {
				return submodule_info[`${ type }_title`]
			}
		},
		// 判断extras模块有没有内容
		extrasNotEmpty () {
			let keys = [ 'language', 'certificate', 'other', 'interest', 'skill' ]
			for (let i = 0; i < keys.length; i++) {
				if (this.extras[keys[i]] && this.extras[keys[i]].description) return true
			}
		},
		// 头像方法
		addAvatar () {
			if (window.location.href.includes('mentor')) return
			//检测是否有profile数据
			// if (!this.profile.id) {
			// 	this.$message.error('请先完善基本信息')
			// 	return false
			// }
			const alertData = {
				show: true,
				type: 'upimg',
				avatar_faqs: this.avatarFaq,
				cancel: close => {
					close()
				},
				confirm: async (close, file, fileType) => {
					close()
					try {
						const { basic_info: { kind, token } } = this.cvDetail
						//同步个人信息数据
						let profile = JSON.parse(JSON.stringify(this.profile))
						let store = await oss(this.ossBeaseOptions)
						let imgName = `${uuid.v1()}.${fileType}`
						//调用
						var blob = dataURLtoBlob(file)
						var fileData = blobToFile(blob, imgName)
						let res = await store.put(`cv/cv_accounts/avatars/${ imgName }`, fileData)
						if (res.res.statusCode !== 200) {
							this.$message.error('图片上传失败')
							return false
						}
						profile.avatar_url = res.url;
						delete profile.show_attr_name;
						if (kind === 'template' || kind === 'sample') {
							try {
								let cvRes = await this.createCvDetail({
									payload: JSON.parse(JSON.stringify(this.cvDetail)),
									dotReload: true
								})
								if (cvRes.code === 1000) {
									this.createProfileData({ payload: profile })
								}
							} catch (error) {
								console.log(error)
							}
						} else if (!this.profile.id) {
							this.createProfileData({ payload: profile, dotReload: true })
						} else {
							this.hasCvUpdateProfile(profile)
						}
					} catch (error) {
						console.log(error)
						this.$message.error('图片上传失败')
						return false
					}
				}
			}
			this.$store.dispatch('app/setAlertData', alertData)
		},
		// 已有简历和profile上传头像
		async hasCvUpdateProfile(profile) {
			try {
				//同步数据
				let profileRes = await this.updateProfileData({ payload: profile });
				if (profileRes.code === 1000) {
					this.$message.success('保存成功')
					// this.setProfileData(profile)
					//同步个人信息备份数据-有可能用户在修改排版样式，不能影响
					let backUpProfile = JSON.parse(JSON.stringify(this.backUpProfile))
					backUpProfile.avatar_url = res.url
					this.setBackUpProfile(profile)
				} else {
					this.$message.success(res.message)
				}
			} catch (error) {
				console.log(error)
			}
		},
		// 删除头像
		deleteAvatar () {
			const alertData = {
				show: true,
				type: 'message',
				messageTitle: '删除提示',
				showCancelButton: true, //取消按钮
				showConfirmButton: true, // 确定按钮
				confirmButtonText: '取消',
				cancelButtonText: '删除',
				cancelButtonClass: 'cvs-edit-cancelButtonClass',
				confirmButtonClass: 'cvs-edit-confirmButtonClass',
				messageContent: `
          <p>删除内容将无法还原</p>
          <p style="color: #FF453E">确定要删除头像吗?</p>
        `,
				confirm: close => {
					close()
				},
				cancel: async close => {
					close()
					let profile = this.profile
					profile.avatar_url = ''
					delete profile.show_attr_name;
					// this.updateProfileData({ payload: profile });
					this.updateVipProfileData({ payload: {avatar_url: ''}, profile: profile } )
					// this.$store.commit('cvsEditor/setProfile', profile)
					// this.$store.dispatch('cvsEditor/editProfile')
				}
			}
			this.$store.dispatch('app/setAlertData', alertData)
		},
		// 编辑校徽
		editSchool () {
			let { kind } = this.cvDetail.basic_info
			if ( kind ==='template' || kind ==='sample' ) {
				this.$message.error('请先完善简历信息')
				return false
			}
			this.$store.dispatch('app/setAlertData', { show: true, type: 'school' })
		},
		// 删除校徽
		deleteSchool () {
			let { kind } = this.cvDetail.basic_info
			if ( kind ==='template' || kind ==='sample' ) {
				this.$message.error('请先完善简历信息')
				return false
			}
			const alertData = {
				show: true,
				type: 'message',
				messageTitle: '删除提示',
				showCancelButton: true, //取消按钮
				showConfirmButton: true, // 确定按钮
				confirmButtonText: '取消',
				cancelButtonText: '删除',
				cancelButtonClass: 'cvs-edit-cancelButtonClass',
				confirmButtonClass: 'cvs-edit-confirmButtonClass',
				messageContent: `
          <p>删除内容将无法还原</p>
          <p style="color: #FF453E">确定要删除校徽吗?</p>
        `,
				confirm: close => {
					close()
				},
				cancel: async close => {
					close()
					let res = await api.cvsEditor.deleteSchoolLogo(this.cvToken)
					if (res.code === 1000) {
						let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
						cvDetail.basic_info.school_logo_id = null
						cvDetail.basic_info.school_logo_url = null
						this.setCvDetail(cvDetail)
						//更新模块管理未选择模块
						this.getFilterModule()

						this.$message.success('删除成功')
					} else {
						this.$message.error(res.message)
					}
				}
			}
			this.$store.dispatch('app/setAlertData', alertData)
		},
		//修改模块排序-非extras
		sortModule(opt, sortType, index) {
			let type = opt.type === "custom" ? opt.id : opt.type;
			let module = JSON.parse(JSON.stringify(this.$store.state.editor[type]));
			let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
			//拿到当前模块数据
			let nowItem = module[index];
			if(sortType === 'up'){
				let nextItem = module[index-1];
				module.splice(index, 1, nextItem);
				module.splice(index-1, 1, nowItem);
			}else{
				let nextItem = module[index+1];
				module.splice(index, 1, nextItem);
				module.splice(index+1, 1, nowItem);
			}
			//拿到整理好之后的模块数据
			let moduleIds = module.map(item=>item.id);
			//整理相关模块的数据id
			if(type==="works" || type==='orgs' || type==='edus' || type==='opus'){
				cvDetail.submodule_info[type+'_ids'] = moduleIds;
			}else{
				//找到相关类型，修改id
				cvDetail.submodule_info.sections_position.forEach(item=>{
					if(item.type === type || item.id === type){
						item.info_ids = moduleIds;
						item.infos = moduleIds;
					}
				})
			}

			//修改之后的顺序同步到vuex中
			this.setModuleData({
				type,
				info: module
			});
			//同步操作之后的id到数据中
			this.setCvDetail(cvDetail);

			//防止重复提交接口
			clearTimeout(sortModuleTimeName)
			sortModuleTimeName = setTimeout(() => {
				console.log('保存')
				let payload = {
					operation_type: 'update_submodule_info',
					submodule_info: this.cvDetail.submodule_info
				}
				this.updateCvDetail(payload)
			}, 300);
		},
		//修改模块排序-extras
		sortExtrasModule(type, sortType, index){
			let extrasPosition = JSON.parse(JSON.stringify(this.extrasPosition))
			let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));

			console.log(type, sortType, index)
			//拿到当前模块数据
			let nowItem = extrasPosition[index];
			if(sortType === 'up'){
				let nextItem = extrasPosition[index-1];
				extrasPosition.splice(index, 1, nextItem);
				extrasPosition.splice(index-1, 1, nowItem);
			}else{
				let nextItem = extrasPosition[index+1];
				extrasPosition.splice(index, 1, nextItem);
				extrasPosition.splice(index+1, 1, nowItem);
			}
			extrasPosition.forEach((item,index)=>{
				extrasPosition[index] = item+'s'
			})
			cvDetail.submodule_info.extras_position = extrasPosition;
			//同步操作之后的id到数据中
			this.setCvDetail(cvDetail);

			//防止重复提交接口
			clearTimeout(sortModuleTimeName)
			sortModuleTimeName = setTimeout(() => {
				console.log('保存')
				let payload = {
					operation_type: 'update_submodule_info',
					submodule_info: this.cvDetail.submodule_info
				}
				this.updateCvDetail(payload)
			}, 300);
		},
	}
}
export const cvOperationMixin = {
	data () {
		return {
			useStateShow: false
		}
	},
	computed: {
		...mapState('me', [ 'personInfo' ])
	},
	methods: {
		// 判断是否可以创建简历
		async verifyCanCreate (lang, token, callback, browseType) {
			let { c_t } = get_tUser()
			this.useStateShow = true
			let res = await api.cvsEditor.canCreateCv(c_t)
			if (res.code === 1000) {
				this.useStateShow = false
				if (res.data[`can_create_${ lang }_cv`]) {
					if (callback) {
						callback()
					} else {
						this.$store.dispatch('app/setAlertData', { show: false })
						window.location.href = `${ window.location.origin }/cvs/${ token }/editor`
					}
				} else {
					if (this.personInfo.is_membership) {
						this.$message.error('已达简历数量上限')
					} else {
						this.$store.dispatch('app/setAlertDataShow', false);
						this.$message.error('已达简历上限，升级会员可创建多份简历');
						setTimeout(() => {
							this.$store.dispatch('app/setAlertData', {show: true, type: 'upVip', browseType});
						}, 300);
					}
					return 'createError'
				}
			} else {
				this.useStateShow = false
				console.log('接口报错')
			}
		}
	}
}
export const cvResumeErrorMixin = {
	data () {
		return {
			editorModuleInfo: null,
			errorInfoTypeName: { //错误标题
				word: '字词错误',
				punc: '标点错误',
				miss: '语法错误',
			},
		}
	},
	computed: {
		// 当前简历里面的 edus, works, orgs 的经历
		experienceInfos () {
			if(!this.editorModuleInfo){
				return []
			}
			let { moduleType, moduleId } = this.editorModuleInfo;
			if(moduleType === 'custom'){
				return this.$store.state.editor[moduleId] || []
			}else{
				return this[moduleType] || this.$store.state.editor[moduleType] || []
			}
		},
	},
	methods: {
		...mapMutations('editor', ['setOpenResumeError', 'setSelectErrorInfo', ]),
		...mapActions('app', [ 'setAlertData' ]),
		// 整理纠错的数据
		getFilterErrorInfo(){
			// 错误类型
			let resumeErrorFilterType = this.resumeErrorFilterType
			// console.log('getFilterErrorInfo 已经调用了', resumeErrorFilterType)
			// 错误信息原始数据
			let errors = JSON.parse(JSON.stringify(this.resumeErrorInfo.errors))
			// 简历信息
			let submodule_info = this.cvDetail.submodule_info
			let sections_position = JSON.parse(JSON.stringify(submodule_info.sections_position))
			// console.log('errors=>>>', errors)
			// console.log('submodule_info=>>>', submodule_info)
			let errorUuidList = [];

			// 循环简历的顺序
			sections_position.forEach(item=>{
				item.errorInfos = []
				// console.log(item.type)
				// 技能/证书及其他
				if(item.type === 'extras'){

				} else if(item.type === 'edus' || item.type === 'works' || item.type === 'orgs'){
					// 循环当前模块的小模块顺序
					submodule_info[item.type+'_ids'].forEach(id=>{
						let errorInfo = {
							moduleId: id,
							errorList: [],
							originText: '', //匹配项纯文字
						}
						// console.log(11111, errors[item.type])
						// 判断是否当前模块下有错误
						if(errors[item.type]){
							// 拿到当前大模块下的 简历小模块
							let level1Item = errors[item.type][id]
							if(level1Item){
								errorInfo.errorList = level1Item.errorList || []
								errorInfo.originText = level1Item.origin_text

								// 过滤已经解决的错误
								errorInfo.errorList.filter(item=> !item.is_correct)

								// 只显示当前筛选的错误类型
								if(resumeErrorFilterType){
									errorInfo.errorList = errorInfo.errorList.filter(errorItem=> errorItem.error_type === resumeErrorFilterType)
								}
								// 整理错误uuid排序
								errorInfo.errorList.forEach(errorItem=>{
									// 保存当前大模块id
									errorItem.moduleId = id
									// let uuid = `${item.type}&${id}&${errorItem.error_type}&${errorItem.index}&${errorItem.end}`;
									let moduleUuid = `${item.type}&${id}&${errorItem.error_type}&${uuid.v1()}`;
									errorItem.uuid = moduleUuid
									errorUuidList.push(moduleUuid)
								})
							}
						}
						// console.log('errorInfo=>>',errorInfo)
						item.errorInfos.push(errorInfo)
					})
				}else {
					// console.log('其他模块=>>', item)
					// 直接循环 ids，比工作模块拿取方便一些
					item.info_ids.forEach(id=>{
						let errorInfo = {
							moduleId: item.id,
							infoId: id,
							errorList: [],
							originText: '', //匹配项纯文字
						}
						// console.log('errors.infos',errors)
						// 一个错误都没有，直接保存
						if(!errors.infos){
							item.errorInfos.push(errorInfo)
							return
						}
						let level1Item = errors.infos[id] || null
						if(level1Item){
							errorInfo.errorList = level1Item.errorList || []
							errorInfo.originText = level1Item.origin_text
							// 过滤已经解决的错误
							errorInfo.errorList.filter(item=> !item.is_correct)

							// 只显示当前筛选的错误类型
							if(resumeErrorFilterType){
								errorInfo.errorList = errorInfo.errorList.filter(item=> item.error_type === resumeErrorFilterType)
							}
							// 整理错误uuid排序
							errorInfo.errorList.forEach(errorItem=>{
								// 保存当前大模块id
								errorItem.moduleId = item.id
								// 保存当前小模块id
								errorItem.infoId = id
								// let uuid = `${item.type}&${id}&${errorItem.error_type}&${errorItem.index}&${errorItem.end}`;
								let moduleUuid = `${item.type}&${id}&${errorItem.error_type}&${uuid.v1()}`;
								errorItem.uuid = moduleUuid
								errorUuidList.push(moduleUuid)
							})
						}
						item.errorInfos.push(errorInfo)
					})
				}
			})
			console.log('errorUuidList=>>>>', errorUuidList)
			// console.log('sections_position=>>>>', sections_position)
			// 保存错误顺序
			this.setErrorUuidList(errorUuidList);
			// 保存数据结构列表
			this.setFilterErrorInfo(sections_position)
		},
		// 启动简历纠错
		async changeResumeErrorCorrection (errorType){
			// 启动纠错模式
			this.setOpenResumeError(true)
			// 筛选想看那种错误类型
			this.setResumeErrorFilterType(errorType || null);
			// 整理纠错的数据
			this.getFilterErrorInfo();
			// 取消弹窗数据
			this.setSelectErrorInfo(null)

			// 简历纠错UUID去除
			let newErrorUuidList = JSON.parse(JSON.stringify(this.errorUuidList))

			// console.log('filterErrorInfo=>>>',this.filterErrorInfo)
			// 先重置所有标记
			document.querySelectorAll('.matchTipsContent').forEach(domItem => {
				domItem.innerHTML = ''
			})
			// 如果没有错误，增加提示
			if(!this.getFilterErrorInfoSize.allLength){
				this.$message.success('未检测出错误信息～');
				return
			}
			if(this.filterErrorInfo && this.filterErrorInfo.length){

				// 保存第一个dom的数据，用作默认点击第一个
				let firstUuidName = null;

				// 循环大模块
				this.filterErrorInfo.forEach(modelItem=>{
					// 暂时不做处理
					if(modelItem.type === 'extras') return

					// 循环大模块下的每个小模块
					modelItem.errorInfos.forEach(sModelItem => {
						// 计算html的方法
						let matchTextContent = document.querySelector(`#${modelItem.type}-${sModelItem.infoId || sModelItem.moduleId} .matchTextContent`);
						// 坐标展示的方法
						let matchTipsContent = document.querySelector(`#${modelItem.type}-${sModelItem.infoId || sModelItem.moduleId} .matchTipsContent`);
						// 拿到当前模块的的简历
						let modelDataList = this.getInfosByType({type: modelItem.type, id: modelItem.id})
						let modelDataInfo = modelDataList.filter(item=> sModelItem.infoId ? item.id === sModelItem.infoId : item.id === sModelItem.moduleId);
						modelDataInfo = modelDataInfo.length ? modelDataInfo[0] : null
						// console.log(JSON.parse(JSON.stringify(modelDataInfo)))

						// 循环小模块下的每个错误
						sModelItem.errorList.forEach((errorItem, errorIndex)=>{
							// console.log('循环小模块下的每个错误=>>>',errorItem)
							// 只处理没有解决的问题
							if(!errorItem.is_correct){
								// 获取当前html的纯文本内容
								let errorOriginText = '';
								if(modelItem.type === 'edus' || modelItem.type === 'works' || modelItem.type === 'orgs'){
									errorOriginText = this.resumeErrorInfo.errors[modelItem.type][sModelItem.infoId || sModelItem.moduleId].origin_text
								}else {
									errorOriginText = this.resumeErrorInfo.errors.infos[sModelItem.infoId || sModelItem.moduleId].origin_text
								}
								// console.log('errorOriginText=>>>', errorOriginText)
								// 计算错误文字在纯文本中 第几个位置
								// console.log('正则',RegExp(getErrorTextRegExp(errorItem.wrong_word),'g'))
								Array.from(errorOriginText.matchAll(RegExp( getErrorTextRegExp(errorItem.wrong_word),'g')), (matchItem, matchIndex) => {
									// 判断下标是否是提示错误的下标位置
									// console.log(matchItem, errorItem ,matchItem.index , errorItem.index)
									if(matchItem.index === errorItem.index){
										errorItem.htmlData = {
											findIndex: matchIndex,
										}
									}
								})
								// 拿到错误文字 所匹配上的 原文本的 所有位置
								let findDescriptionErrorList = Array.from( modelDataInfo.description.matchAll(RegExp(errorItem.regExp, 'g')) )
								// 没有获取到dom || 没获取到坐标位置 || 没有在原文本中发现此错误, 不进行操作并标记此功能已修复
								if(!matchTextContent || !matchTipsContent || !errorItem.htmlData || !findDescriptionErrorList.length){
									console.log('没获取到dom', matchTextContent, matchTipsContent, errorItem)
									console.log('没获取到坐标位置', errorItem)
									console.log('没有在原文本中发现此错误', errorItem.regExp, errorItem)
									newErrorUuidList = newErrorUuidList.filter(uuid => uuid!==errorItem.uuid)
									// 找不到直接标记为 已修复此错误
									let data = {
										moduleType: modelItem.type,
										newOriginText: errorOriginText,
										offsetSize: 0,
										selectErrorInfo: {
											infoId: sModelItem.infoId,
											moduleId: sModelItem.moduleId,
											modelData: {
												errorInfo: errorItem
											},
										},
									}
									this.setResumeErrorItemInfo(data)
									return
								}

								// 添加锚点及功能
								findDescriptionErrorList.forEach( (matchItem, matchIndex) => {
									// console.log('matchItem=>>', matchItem)
									// 带标签的第几个 === 不带标签的第几个
									if(matchIndex === errorItem.htmlData.findIndex){
										// console.log('进来了', errorItem)
										// 保存到原数据里当前的一些匹配信息
										errorItem.htmlData = {
											...errorItem.htmlData,
											...matchItem,
										}

										// 拿到截取字符串之前的文字
										let beforeText = modelDataInfo.description.substring(0, matchItem.index);
										// console.log('match=>matchItem=>>>', matchItem)
										// console.log('beforeText=>>>', beforeText)

										// 添加dom
										let matchTextStartId = new Date().getTime();
										matchTextContent.innerHTML= `${beforeText}<span id="${matchTextStartId}">${matchItem[0]}</span>`
										// 插入元素的dom
										let positionDom = document.getElementById(matchTextStartId);
										// 计算需要获取错误提醒的位置及返回dom
										let TipsData = getErrorTextPosition({
											fatherContent: matchTextContent, // 父级元素
											positionDom, //元素
											errorItem, // 错误item
											modelItemType: modelItem.type,
											moduleId: sModelItem.infoId || sModelItem.moduleId, // 当前模块id
											wrap: false, //换行标记
										});
										// console.log('TipsData=>>>', TipsData)

										// 判断是否是折行，折行需要每个字都渲染一次
										if(TipsData.beyond){
											// console.log('超出预期高度')
											let spanList = ``
											let wrongWordList = errorItem.wrong_word.split('');
											wrongWordList.forEach(wordItem=>{
												spanList+=`<span class="${matchTextStartId}-matchTextStart">${wordItem}</span>`
											})
											// 添加dom
											matchTextContent.innerHTML= `${beforeText}${spanList}`
											document.getElementsByClassName(`${matchTextStartId}-matchTextStart`).forEach((domItem, domIndex)=>{
												// 计算需要获取错误提醒的位置及返回dom
												let newTipsData = getErrorTextPosition({
													fatherContent: matchTextContent, // 父级元素
													positionDom: domItem, //元素
													errorItem, // 错误item
													modelItemType: modelItem.type,
													moduleId: sModelItem.infoId || sModelItem.moduleId, // 当前模块id
													wrap: true, //换行标记
												});
												// console.log('超出高度,单个item',newTipsData, wrongWordList, domIndex, wrongWordList[domIndex])
												if(newTipsData.tipsDom){
													newTipsData.tipsDom.innerHTML = wrongWordList[domIndex]
												}
												matchTipsContent.append(newTipsData.tipsDom)
											})
										}else{
											// console.log('TipsData',TipsData)
											TipsData.tipsDom.innerHTML = matchItem[0]
											matchTipsContent.append(TipsData.tipsDom)
										}
										// console.log('new=>>errorItem+>>>>', errorItem)
									}
								})

								// 保存第一个错误
								if(!firstUuidName){
									firstUuidName = errorItem.uuid
								}
								// console.log('整理之后的errorItem=>>', errorItem)
							}
						})
					})
				})

				// 给所有标记增加事件监听
				this.bindHighlightMethod();

				// 重新同步一次uuid，有可能过滤掉了一部分错误
				this.setErrorUuidList(newErrorUuidList);

				// 如果没有错误，弹出相应的错误
				if(!newErrorUuidList.length){
					this.$message.success(this.resumeErrorFilterType ? `${this.errorInfoTypeName[this.resumeErrorFilterType]}已全部修改` : '当前简历没有错误啦');
				}

				// 如果找到第一个错误，执行点击时事件
				if(firstUuidName){
					setTimeout(() => {
						let firstDom = document.querySelector(`.matchTipsContent .highlightContainer[data-uuid="${firstUuidName}"]`);
						let fatherDom = document.querySelector('.cvs-component')
						if( fatherDom && firstDom){
							let position = getOffsetRelative(firstDom).top*this.scale - getOffsetRelative(fatherDom).top;
							fatherDom.scrollTop = position-50
						}
						firstDom && firstDom.click()
					}, 500);
				}

			}

		},
		// 给所有标记增加事件监听
		bindHighlightMethod(highlightContainer){
			if(!highlightContainer){
				highlightContainer = document.querySelectorAll('.matchTipsContent .highlightContainer');
			}
			highlightContainer.forEach(domItem => {
				// console.log(domItem)
				// 绑定移入事件
				domItem.onmouseenter = (e) => {
					let className = domItem.getAttribute('data-uuid');
					document.querySelectorAll(`.matchTipsContent .highlightContainer[data-uuid="${className}"]`).forEach(sitem=>{
						sitem.classList.add('highlightContainerActive')
					})
				}
				// 绑定移出事件
				domItem.onmouseleave = () => {
					let className = domItem.getAttribute('data-uuid');
					// console.log(className , this.selectErrorInfo.className)
					if(className === this.selectErrorInfo.className){
						return
					}
					document.querySelectorAll(`.matchTipsContent .highlightContainer[data-uuid="${className}"]`).forEach(sitem=>{
						sitem.classList.remove('highlightContainerActive')
					})
				}
				// 点击方法监听
				domItem.onclick = () => {
					let isWrap = domItem.getAttribute('data-wrap'); //标记换行
					let className = domItem.getAttribute('data-uuid');
					let positionData = className ? className.split('&') : null;
					let domList = document.querySelectorAll(`.matchTipsContent .highlightContainer[data-uuid="${className}"]`)
					console.log('positionData=>>>', className, positionData)
					if(positionData){
						// 添加选中样式
						document.querySelectorAll(`.matchTipsContent .highlightContainer`).forEach(sitem=>{
							if(sitem.getAttribute('data-uuid') === className){
								sitem.classList.add('highlightContainerActive')
							}else{
								sitem.classList.remove('highlightContainerActive')
							}
						})

						// 整理参数
						let selectErrorInfo = {
							position: {
								left: 0,
								right: 0,
							},
							className: className,
							modelPosition: positionData,
							modelData: null,
							isWrap: false,
							moduleId: '',
							infoId: '',
							originText: '', //匹配项纯文字
						}

						let fatherContent = document.getElementById('cv-container')
						let positionDom = domList[0]
						// 父级相对位置
						let fatherLeft = getOffsetRelative(fatherContent).left;
						let fatherTop = getOffsetRelative(fatherContent).top;
						// 计算位置的元素相对位置
						let positionLeft = getOffsetRelative(positionDom).left;
						let positionTop = getOffsetRelative(positionDom).top;
						selectErrorInfo.position = {
							left: positionLeft - fatherLeft,
							top: positionTop - fatherTop + positionDom.offsetHeight,
						}
						if(domList.length >1){
							selectErrorInfo.isWrap = isWrap==='true';
						}
						//获取当前dom对应的数据
						this.showModelErrorTips(selectErrorInfo);

					}else{
						console.log('拿不到元素数据', domItem)
					}
				}
			})
		},
		// 整理当前选中的模块数据
		showModelErrorTips(selectErrorInfo){
			// 循环大模块
			this.filterErrorInfo.forEach(item=>{
				// console.log(item.type, item)
				if(selectErrorInfo.modelPosition[0] === item.type){
					// 遍历小模块查找是否属于这个小模块
					item.errorInfos.forEach((errorItem, errorIndex)=>{

						if(errorItem.infoId ? errorItem.infoId == selectErrorInfo.modelPosition[1] : errorItem.moduleId == selectErrorInfo.modelPosition[1] ){
							// 遍历错误信息，找到index && end相同位置的数据
							errorItem.errorList.forEach((sErrorItem, sErrorIndex)=>{
								if(sErrorItem.uuid == selectErrorInfo.className ){
									console.log(errorItem)
									// 拿到原匹配纯文字
									selectErrorInfo.originText = errorItem.originText;
									selectErrorInfo.moduleId = errorItem.moduleId;
									selectErrorInfo.infoId = errorItem.infoId;
									// 整理dom相关
									selectErrorInfo.modelData = {
										level2Index: errorIndex,
										level3Index: sErrorIndex,
										errorInfo: sErrorItem
									}
								}
							})
						}

					})

				}
			})
			console.log('selectErrorInfo=>>>', selectErrorInfo)
			// 同步原数据中
			this.setSelectErrorInfo(selectErrorInfo)
		},



		/*
			* 修改错误项相关
		*/
		// 获取当前操作的错误经历库列表
		getExperience(selectErrorInfo){
			let moduleType = selectErrorInfo.modelPosition[0]
			let { moduleId, infoId} = selectErrorInfo
			console.log(moduleType)
			console.log(moduleId)
			console.log(this.experienceList)
			if(moduleType === 'custom'){
				return this.experienceList[moduleId]
			}else{
				return this.experienceList[moduleType]
			}

		},
		// 保存
		async reviseResumeErrorInfo (props) {
			let { editorModule, selectErrorInfo, successCallBack, quoteCallBack } = props
			let currentExperienceList = this.getExperience(selectErrorInfo)
			let { id, mentor_id, custom_section_id } = editorModule
			// 找到在经历库中当前 id 所在的位置
			const experienceIndex = currentExperienceList ? currentExperienceList.findIndex(item => item.id === id) : -1
			// 当前编辑的什么类型
			let moduleType = selectErrorInfo.modelPosition[0];

			console.log('currentExperienceList=>>', currentExperienceList)
			console.log('editorModule=>>>', editorModule)
			console.log('selectErrorInfo=>>>', selectErrorInfo)
			console.log({id, type: moduleType, moduleId: custom_section_id, })
			// 保存当前操作的数据
			this.editorModuleInfo = {
				operation: 'update',
				editorModuleInfo: editorModule,
				moduleType,
				moduleId: custom_section_id,
			}
			/*
			1. experienceIndex 大于 -1 的话说明当前经历是用户已有经历，需要对比是否修改
			 **/
			if (mentor_id && this.isMentorEditor) {
				// this.errorExperienceChange('update')
			} else if (experienceIndex > -1) {
				if (await this.verifyFormData({infoId: id, type: moduleType, moduleId: custom_section_id, })) {
					const alertData = {
						...this.alertData,
						messageTitle: '修改提示',
						confirmButtonText: '修改',
						cancelButtonText: '不修改',
						messageContent: `<p>此段经历在其他简历中被引用，</p><p style="color: #FF453E">如果修改会同步到其他简历</p>`,
						confirm: async close => {
							this.errorExperienceChange(successCallBack)
							close()
						},
						cancel: close => {
							// 提示被引用
							quoteCallBack && quoteCallBack()
							// this.errorExperienceChange({
							// 	operation: 'create',
							// 	editorModuleInfo: editorModule,
							// 	moduleType
							// })
							close()
						},
					}
					this.setAlertData(alertData)
				} else {
					this.errorExperienceChange(successCallBack)
				}
			} else {
				// this.errorExperienceChange('create')
			}
			// this.errorExperienceChange('update')
		},
		// 更新或者创建经历
		async errorExperienceChange (successCallBack) {
			let { operation, editorModuleInfo, moduleType, moduleId } = this.editorModuleInfo
			let res = {}
			let payload = {
				...editorModuleInfo,
				start_at: editorModuleInfo.start_at ? moment.utc(editorModuleInfo.start_at) : null,
				end_at: editorModuleInfo.end_at ? moment.utc(editorModuleInfo.end_at) : null,
				lang: this.cvDetail.basic_info.lang
			}
			console.log('提交payload=>>',moduleType, payload)

			// return
			// 只做更新，不做创建
			this.setIsSendRequest(false)
			res = {
				// code: 1000,
				// data: {
				// 	info: payload
				// }
			}
			let custom = !['edus', 'orgs', 'works'].includes(moduleType)
			if(!custom){
				res = await this.updateExperience({ type: moduleType, payload });
			} else{
				res = await this.updateCustomInfo(payload);
			}
			console.log('是否是自定义', custom)
			if (res.code === 1000) {
				if(!custom){
					await this.errorCvDetailChange({
						data: res.data[moduleType],
						// data: res.data.info,
					})
				}else{
					await this.customCvDetailChange({
						data: res.data.info,
					})
				}
				successCallBack();
			}
		},
		// 更新或者创建简历
		async errorCvDetailChange (props) {
			let { data, } = props
			let { moduleType, operation, editorModuleInfo } = this.editorModuleInfo;

			let { submodule_info, basic_info, format_info, basic_info: { kind }, submodule_info: { sections_position } } = this.cvDetail
			let ids = submodule_info[`${ moduleType }_ids`]
			let infos = JSON.parse(JSON.stringify(this.experienceInfos))
			let position = JSON.parse(JSON.stringify(sections_position))

			// 找到简历中当前 id 所在位置
			const infoIndex = ids.findIndex(item => item === data.id)

			let payload = {
				submodule_info: {
					...submodule_info,
					sections_position: position,
					[`${ moduleType }_ids`]: Array.from(new Set(ids)).filter(item => !!item)
				},
				operation_type: 'update_submodule_info'
			}
			let res = await this.updateCvDetail({ ...payload, saveModule: true });

			if (res.code === 1000) {
				infos[infoIndex] = data
				//同步数据
				this.setModuleData({ type: moduleType, info: infos })

				//更新经历库模块信息
				this.updateExperienceModule({
					key: moduleType,
					info: data,
					// operation: operation,
					operation: 'edit',
					updateBackUp: true,
				})

			}
		},
		// 更新自定义模块简历数据
		async customCvDetailChange (props){
			console.log('customCvDetailChange')
			let { data, } = props
			let { moduleType, operation, editorModuleInfo } = this.editorModuleInfo;

			moduleType = Number(moduleType) >= 0 ? 'custom' : moduleType

			let { submodule_info, basic_info, format_info, basic_info: { kind }, submodule_info: { sections_position, custom_sections_ids } } = this.cvDetail
			// console.log('editorModuleInfo',this.editorModuleInfo)
			// console.log('experienceInfos',this.experienceInfos)
			let infos = JSON.parse(JSON.stringify(this.experienceInfos))
			let position = JSON.parse(JSON.stringify(sections_position))
			// 获取当前编辑的模块id
			let customSectionId = data.custom_section_id;

			// 寻找当前模块是否在sections_position中
			const moduleIndex = sections_position.findIndex(item => item.type === 'custom' ? item.id === customSectionId : item.type === moduleType)
			let infoIndex = -1
			if (moduleIndex > -1) {
				let ids = position[moduleIndex].info_ids
				infoIndex = ids.findIndex(item => item === data.id)
			}

			position.forEach(item => {
				if ((item.type === moduleType && item.type !== 'custom') || item.id === data.custom_section_id) {
					item.id = data.custom_section_id
					if (infoIndex > -1 && customSectionId === data.custom_section_id) {
						item.info_ids[infoIndex] = data.id
					} else if (customSectionId === data.custom_section_id) {
						item.info_ids = [ ...item.info_ids, data.id ]
					} else {
						item.info_ids = [ data.id ]
					}
					item.info_ids = Array.from(new Set(item.info_ids))
				}
			})

			let customsIds = position.filter(item => item.id)
			let payload = {
				submodule_info: {
					...submodule_info,
					custom_sections_ids: customsIds.map(item => item.id),
					sections_position: position,
				},
				operation_type: 'update_submodule_info'
			}

			// 同步到经历库里的数据
			let experienceModuleData = {
				isCustom: moduleType === 'custom',
				key: moduleType === 'custom' ? customSectionId : moduleType,
				info: data,
				// operation: operation,
				operation: 'edit',
				updateBackUp: true,
			}
			// console.log('experienceModuleData',experienceModuleData)

			let res = await this.updateCvDetail({ ...payload, saveModule: true })

			if (res.code === 1000) {
				if (infoIndex > -1 && customSectionId === data.custom_section_id) {
					infos[infoIndex] = data
				} else {
					infos = [ data ]
				}
				if (experienceModuleData.key === 'custom') {
					let editorState = JSON.parse(JSON.stringify(this.$store.state.editor))
					editorState[experienceModuleData.key] = infos
					this.$store.replaceState({
						...this.$store.state,
						editor: {
							...editorState,
							onePageFunction: this.$store.state.editor.onePageFunction,
							saveFormDataByDialog: this.$store.state.editor.saveFormDataByDialog,
							create_custom: []
						}
					})
				} else {
					this.setModuleData({ type: experienceModuleData.key, info: infos })
				}
				//更新经历库模块信息
				this.updateExperienceModule(experienceModuleData)
			} else {
				this.$message.error(res.message)
			}

		},
		// 判断经历有没有被引用
		async verifyFormData (props) {
			let { moduleId, infoId, type } = props
			let res = null
			if(moduleId){
				res = await api.cvsEditor[`customVerify`](moduleId, infoId)
			}else{
				res = await api.cvsEditor[`${ type }Verify`](infoId)
			}
			if (res.code === 1000) {
				return res.data.imported
			} else {
				this.$message.error(res.message)
				return false
			}
		},
		// 是否取消纠错
		showCloseResumeError(){
			let alertData = {
				show: true,
				type: 'message',
				messageTitle: '温馨提示',
				showCancelButton: true,
				showConfirmButton: true, // 确定按钮
				cancelButtonText: '继续纠错',
				confirmButtonText: '退出纠错',
				messageContent: `再次进入需要重新检查，确定退出纠错模式吗？`,
				confirm: async close => {
					this.setAlertData({
						...alertData,
						show: false,
					})
					// 关闭纠错模式
					this.setOpenResumeError(false)
					// 取消弹窗数据
					this.setSelectErrorInfo(null)
					// 清除数据
					document.querySelectorAll('.matchTipsContent').forEach(domItem=>{
						domItem.innerHTML = ''
					})
				},
				cancel: close => {
					this.setAlertData({
						...alertData,
						show: false,
					})
				},
			}
			this.setAlertData(alertData)
		},


	}
}
export const styleMixin = {
	data() {
		return {
			currentStyleIndex: 0,
			isFirstRound: true,
			isRotating: false,
		}
	},
	methods: {
		async replaceStyle() {
			const { basic_info } = this.cvDetail
			const STYLES = basic_info.lang === 'cn' ? CN_CV_STYLES : EN_CV_STYLES
			const STYLE_ITEM = STYLES[this.currentStyleIndex];

			const payload = {
				format_info: STYLE_ITEM,
				operation_type: 'update_format_info'
			}

			this.isRotating = true;
      timer = setTimeout(() => {
        this.isRotating = false;
      }, 300); // 动画持续时间

			await this.$store.dispatch('editor/updateCvDetail', payload);
			this.isFirstRound = false

			if (this.currentStyleIndex === 3) {
				this.currentStyleIndex = 0
			} else {
				this.currentStyleIndex += 1
			}
		},
		beforeDestory() {
			clearTimeout(timer)
		}
	}
}
